export default __webpack_public_path__ + "static/media/signoutIcon_profile.dbe68b64.svg";